import { Button, ButtonVariant, Input, DateInput } from "shared/components";
import { CombinedIncomeLayout } from "../components/Layout";
import { toast } from "react-toastify";
import { CombinedIncomeSubStep } from "../../../constants";
import { useFormTyped } from "shared/hooks/use-form-typed";
import { object, string } from "yup";
import { useCombinedIncome } from "../context";
import { getErrorMessage } from "utils/error";

type OtherIncomeDetailsFormData = {
  description: string;
  paid_from: string;
  start_date: string;
};

const validationSchema = object({
  description: string().required("Income description is required"),
  paid_from: string().required("Paid by / from is required"),
  start_date: string().required("Start date is required")
});

export const OtherIncomeDetailsStep = () => {
  const { updateStepMutation, stepData, refetchVerification } =
    useCombinedIncome();

  const { register, onSubmit } = useFormTyped<OtherIncomeDetailsFormData>(
    {
      description: stepData.description || "",
      paid_from: stepData.paid_from || "",
      start_date: stepData.start_date || ""
    },
    validationSchema
  );

  const handleSubmit = (formValues: OtherIncomeDetailsFormData) => {
    updateStepMutation.mutate(
      {
        lastStep: CombinedIncomeSubStep.PreTaxIncome,
        description: formValues.description,
        paid_from: formValues.paid_from,
        start_date: formValues.start_date
      },
      {
        onSuccess: () => {
          refetchVerification();
        },
        onError: (error) => {
          toast.error(
            getErrorMessage(error) || "Failed to save income details"
          );
        }
      }
    );
  };

  return (
    <form onSubmit={onSubmit({ onSuccess: handleSubmit })}>
      <CombinedIncomeLayout
        title="Add income details"
        footer={
          <Button
            className="w-[132px]"
            type="submit"
            loading={updateStepMutation.isPending}
            variant={ButtonVariant.PRIMARY}
          >
            Continue
          </Button>
        }
      >
        <Input
          {...register("description")}
          id="description"
          label="Income description"
          labelClassName="mt-4"
          required
          legacyErrorMargins={false}
        />

        <Input
          {...register("paid_from")}
          id="paid-from"
          label="Paid by / from"
          placeholder="Nurse"
          labelClassName="mt-4"
          required
          legacyErrorMargins={false}
        />

        <div className="mt-4">
          <DateInput
            {...register("start_date")}
            id="start-date"
            label="Start date"
            ignoreDay
            required
          />
        </div>
      </CombinedIncomeLayout>
    </form>
  );
};
